import { Button } from "Infrastructure/Components/Forms/Buttons/Button";
import { Resources, useResource } from "Infrastructure/Translations/Resources";
import { Stack, useTheme } from "@mui/material";
import { Check, Send, X } from "lucide-react";

export const ActionButtons = ({
  status,
  onClose,
  onApprove,
  onReject,
  onSubmitCompletion,
  isLoading,
}: {
  status: "requested" | "active" | "pending" | "completed" | "canceled";
  onClose: () => void;
  onApprove?: () => void;
  onReject?: () => void;
  onSubmitCompletion?: () => void;
  isLoading: boolean;
}) => {
  const { t } = useResource();
  const { customSpacing } = useTheme();

  return (
    <Stack direction="row" justifyContent="flex-end" gap={customSpacing.md}>
      <Button
        type="secondary"
        label={t(Resources.Common.Close)}
        onClick={onClose}
      />

      {status === "requested" && onApprove && onReject && (
        <>
          <Button
            type="secondary"
            label={t(Resources.RequestCards.RequestDetail.Actions.Reject)}
            iconStart={<X size={16} />}
            onClick={onReject}
            disabled={isLoading}
          />
          <Button
            type="primary"
            label={t(Resources.RequestCards.RequestDetail.Actions.Approve)}
            iconStart={<Check size={16} />}
            onClick={onApprove}
            disabled={isLoading}
          />
        </>
      )}

      {status === "active" && onSubmitCompletion && (
        <Button
          type="primary"
          label={t(
            Resources.RequestCards.RequestDetail.Actions.SubmitForReview,
          )}
          iconStart={<Send size={16} />}
          onClick={onSubmitCompletion}
          disabled={isLoading}
        />
      )}

      {status === "pending" && onApprove && onReject && (
        <>
          <Button
            type="secondary"
            label={t(
              Resources.RequestCards.RequestDetail.Actions.RejectCompletion,
            )}
            iconStart={<X size={16} />}
            onClick={onReject}
            disabled={isLoading}
          />
          <Button
            type="primary"
            label={t(
              Resources.RequestCards.RequestDetail.Actions.ApproveCompletion,
            )}
            iconStart={<Check size={16} />}
            onClick={onApprove}
            disabled={isLoading}
          />
        </>
      )}
    </Stack>
  );
};
